var React = require('react');

function Minus (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M15.96 9V7H0.0400391V9H15.96Z","fill":"currentColor"}));
}

Minus.defaultProps = {"viewBox":"0 0 16 16","data-testid":"element-icon-minus","data-icon":"minus","width":"16","height":"16","focusable":"false","aria-hidden":"true","color":"white"};

module.exports = Minus;

Minus.default = Minus;
